export class Account {
    id = -1;
    name = '';

    deserialize(data: any) {
        this.id = data.id ?? -1;
        this.name = data.name && data.number_without_suffix ? `(${data.number_without_suffix}) ${data.name}` : '';
        return this;
    }

    static Sort(a1: Account, a2: Account) {
        return a1.name.localeCompare(a2.name);
    }
}
